import React from 'react';
import { ArrowRight } from 'lucide-react';

const Button = ({ 
  text = 'Click Here', 
  href = '#', 
  variant = 'primary',
  size = 'default',
  showArrow = false,
  className = '' 
}) => {
  const variantClasses = {
    primary: 'bg-primary text-white hover:bg-primary-hover',
    secondary: 'bg-secondary text-white hover:bg-secondary-hover',
    outline: 'border border-primary text-primary hover:bg-primary hover:text-white',
    ghost: 'text-primary hover:bg-primary/10',
  };

  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    default: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
  };

  return (
    <a 
      href={href}
      className={`inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
    >
      {text}
      {showArrow && <ArrowRight size={16} />}
    </a>
  );
};

Button.builderConfig = {
  props: {
    text: {
      type: 'text',
      label: 'Button Text',
      default: 'Click Here',
    },
    href: {
      type: 'text',
      label: 'Link URL',
      default: '#',
    },
    variant: {
      type: 'select',
      label: 'Style',
      default: 'primary',
      options: [
        { value: 'primary', label: 'Primary' },
        { value: 'secondary', label: 'Secondary' },
        { value: 'outline', label: 'Outline' },
        { value: 'ghost', label: 'Ghost' },
      ],
    },
    size: {
      type: 'select',
      label: 'Size',
      default: 'default',
      options: [
        { value: 'sm', label: 'Small' },
        { value: 'default', label: 'Default' },
        { value: 'lg', label: 'Large' },
      ],
    },
    showArrow: {
      type: 'boolean',
      label: 'Show Arrow',
      default: false,
    },
  },
};

export default Button;
